// @flow

import * as React from "react"

type Props = {
  children: React.Node,
}

// TODO: dependency on content-wrapper style is not optimal and should be removed
const RouteWrapper = ({ children }: Props) => <div id="content-wrapper">{children}</div>

export default RouteWrapper
